// Central enum-like definition for planogram editing UI modes
// Usage: PlanogramEditMode.ADD_PRODUCT | PlanogramEditMode.INITIALIZATION
export const PlanogramEditMode = Object.freeze({
    ADD_PRODUCT: 'add_product',
    INITIALIZATION: 'initialization',
});

export default PlanogramEditMode;


